export default {
  keywordHistories: [],
  keywordHistory: undefined,
};
